import React, { useState } from 'react';
import './PersonsDisplay.scss';
import { Avatar } from '../../features/avatar/Avatar';
import { DossierMember } from '../../models/DossierMember';
import classNames from 'classnames';

export interface IPersonsDisplayProps {
  persons: DossierMember[];
  plural?: string;
}

function PersonsDisplay({ persons, plural }: IPersonsDisplayProps): JSX.Element|null {
  const [expanded, setExpanded] = useState<boolean>(false);
  const personCount = persons.length;

  if (personCount === 0) {
    return null;
  }

  plural = plural ?? 'personen';

  const renderCollapsed = ({ plural }: { plural: string }): JSX.Element => {
    const displayLine = personCount === 1 ? persons[0].user.name : `${personCount} ${plural}`;
    return <>
      <div className="persons-display__avatars">{ persons.map(person => <Avatar key={person.memberId} user={person.user} />) }</div>
      <div className="persons-display__info">
        <div className="persons-display__name">{displayLine}</div>
        { personCount === 1 && <div className="persons-display__role">{ persons[0].getRoleText({ capitalize: true }) }</div>}
      </div>
    </>;
  };

  const renderExpanded = (): JSX.Element[] => persons.map(relation => (
    <div key={relation.memberId} className="persons-display__list-item">
      <Avatar className="persons-display__avatar" user={relation.user} />
      <div className="persons-display__info">
        <div className="persons-display__name">{ relation.user.name }</div>
        <div className="persons-display__role">{ relation.getRoleText({ capitalize: true }) }</div>
      </div>
    </div>
  ));

  const Type = (personCount > 1 ? 'button' : 'div') as keyof JSX.IntrinsicElements;
  return <Type
    className={classNames('persons-display', { 'persons-display--expanded': expanded })}
    aria-label={personCount > 1 ? `Alle ${plural} weergeven` : undefined}
    onClick={() => setExpanded(!expanded)}
    title={persons.map(person => person.user.name).join(', ')}
  >
    { expanded ? renderExpanded() : renderCollapsed({ plural }) }
  </Type>;
}

export default PersonsDisplay;
